import React from 'react';
import {CorrespondenceTrackingView} from '@one-hub/onehub-web-lib';
import {ICorrespondenceTrackingProps} from 'app/views/correspondence/components/correspondenceTracking/correspondenceTracking.types';

export const CorrespondenceTracking = ({tracking}: ICorrespondenceTrackingProps) => (
    <CorrespondenceTrackingView tracking={tracking} />
);
